import { useState, useCallback } from 'react';

/**
 * Custom hook for managing success and error notification modals
 * @returns {Object} Modal state and control functions
 */
export const useNotificationModal = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successTitle, setSuccessTitle] = useState('Success');
  const [errorTitle, setErrorTitle] = useState('Error');

  const showSuccess = useCallback((message, title = 'Success') => {
    setSuccessMessage(message);
    setSuccessTitle(title);
    setShowSuccessModal(true);
  }, []);

  const showError = useCallback((message, title = 'Error') => {
    setErrorMessage(message);
    setErrorTitle(title);
    setShowErrorModal(true);
  }, []);

  const hideSuccess = useCallback(() => {
    setShowSuccessModal(false);
  }, []);

  const hideError = useCallback(() => {
    setShowErrorModal(false);
  }, []);

  return {
    // Success modal state
    showSuccessModal,
    successMessage,
    successTitle,
    
    // Error modal state
    showErrorModal,
    errorMessage,
    errorTitle,
    
    // Control functions
    showSuccess,
    showError,
    hideSuccess,
    hideError,
  };
};
